import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Button, Col, Container, Image, Modal, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FlagReportInstance } from "../utils/flagReportClass";
import { FormatInstance } from "../utils/formatClass";

export const AdminAppReportsFlagsComponent = () => {
  const { reports, isLoading } = useSelector((state: any) => state.flagReport);
  const [selectedFlag, setSelectedFlag] = useState(null);
  const [flagDetails, setFlagDetails] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [showClarifyPopup, setShowClarifyPopup] = useState(false);

  useEffect(() => {
    if (reports.length === 0) {
      FlagReportInstance.getAllReports();
    }
  }, [reports.length]);

  const handleFlagClick = async (flagId: string) => {
    try {
      const response = await FlagReportInstance.getFlaggedItem(flagId);
      console.log("FLAG DETAILS:", response);
      setFlagDetails(response);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching flag details:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFlagDetails(null); // Reset flag details when modal is closed
  };

  const renderFlagDetails = () => {
    if (!flagDetails) return <p>Loading...</p>;

    const { flag, item, user, count } = flagDetails;

    return (
      <>
        <h4>Flag Information</h4>
        <p>
          <strong>Flag Count:</strong> {count}
        </p>
        <p>
          <strong>Reason:</strong> {flag?.reason}
        </p>
        <p>
          <strong>Item Type:</strong> {flag?.itemType}
        </p>
        <h4 className="mt-5">Item Details</h4>
        {flag.itemType === "image" && (
          <>
            <Image
              src={item.url}
              alt="Flagged Image"
              fluid
              style={{
                maxHeight: "400px",
                objectFit: "contain",
                margin: "0 auto",
              }}
            />
            {item.caption && (
              <p>
                <strong>Caption:</strong> {item.caption}
              </p>
            )}
          </>
        )}
        {flag.itemType === "comment" && (
          <p>
            <strong>Comment:</strong> {item.text}
          </p>
        )}
        {flag.itemType === "productReview" && (
          <>
            <Image
              src={item.imageUrl}
              alt="Product Review Image"
              fluid
              style={{
                maxHeight: "400px",
                objectFit: "contain",
                margin: "0 auto",
              }}
            />
            <p>
              <strong>Review:</strong> {item.comment}
            </p>
          </>
        )}
        {flag.itemType === "review" && (
          <>
            <Image
              src={item.imageUrl}
              alt="Review Image"
              fluid
              style={{
                maxHeight: "400px",
                objectFit: "contain",
                margin: "0 auto",
              }}
            />
            <p>
              <strong>Review:</strong> {item.review}
            </p>
          </>
        )}
        <h5 className="mt-5">User Details</h5>
        <p>
          <strong>Name:</strong> {user?.username}
        </p>
        <p>
          <strong>Email:</strong> {user?.email}
        </p>
      </>
    );
  };

  const handleShowClarifyPopup = () => {
    setShowClarifyPopup(true);
  };

  const handleCloseClarifyPopup = () => {
    setShowClarifyPopup(false);
  };

  const handleFlagResolve = async () => {
    try {
      await FlagReportInstance.resolveFlag(flagDetails.flag.id);
      handleCloseModal();
      setShowClarifyPopup(false);
      FlagReportInstance.getAllReports();
    } catch (error) {
      console.error("Error resolving flag:", error);
    }
  };

  return (
    <>
      <Container className="py-4">
        <Row>
          <Col>
            <h3>App Reports/Flags</h3>
          </Col>
        </Row>
        <Row className="pt-3">
          <Col>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Report Time</th>
                    <th>Reason</th>
                    <th>Item Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((report: any) => (
                    <tr key={report.id}>
                      <td>{FormatInstance?.formatDate(report.createdAt) || "no date found"}</td>
                      <td>{report?.reason || "no reason selected"}</td>
                      <td>{report?.itemType || "no type found"}</td>
                      <td>
                        <Button variant="primary" onClick={() => handleFlagClick(report.id)}>
                          View Details
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal} centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Flag Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderFlagDetails()}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="danger" onClick={handleShowClarifyPopup}>
            Resolve
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showClarifyPopup} onHide={handleCloseClarifyPopup} centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Resolution</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to resolve this flag?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseClarifyPopup}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleFlagResolve}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
